<template>
    <v-app-bar app flat fixed >
        <v-toolbar-title class="headline" v-if="route()">
            <span class="hidden-xs-only">STAG Legal</span><span class="hidden-md-and-down"> Rechtsanwaltsgesellschaft UG</span>
            <v-avatar
                    class="hidden-sm-and-up overflow-hidden"
                    size="32"
                    tile
            ><img
                    :src="require('@/assets/Logo.png')"
                    alt=""
            ></v-avatar>
        </v-toolbar-title>
        <v-spacer v-if="route()"></v-spacer>
      <!-- TODO slider from the right instead of !$vuetify.breakpoint.smAndDown -->
        <v-toolbar-items v-if="route() && !$vuetify.breakpoint.smAndDown">
          <v-btn
                    text
                    style="margin: 0px"
                    @click="$vuetify.goTo('#home')"
            >
                <span>Home</span>
            </v-btn>
            <v-btn
                    text
                    v-for="buttons in button"
                    :key="buttons.id"
                    style="margin: 0px"
                    @click="$vuetify.goTo(buttons.ref)"
            >
                <span>{{buttons.title}}</span>
            </v-btn>

          <v-btn
              text
              style="margin: 0px"
              to="neuigkeiten"
          >
            <span>aktuelle urteile</span>
          </v-btn>
            <v-btn
                    text
                    href="mailto:info@stag-legal.de?subject=Kontaktanfrage%20von%20der%20Webseite&amp;body=Sehr%20geehrte%20Frau%20Golzo,%0D%0A%0D%0A"
            >
                <span class="mr-2">Kontakt</span>
            </v-btn></v-toolbar-items>
        <v-toolbar-items v-if="!route()">
            <v-btn
                    text
                    style="margin: 0px;"
                    to="/"
            >
                <span>Zurück</span>
            </v-btn>
          <v-spacer></v-spacer>

        </v-toolbar-items>
      <v-spacer v-if="!route()"></v-spacer>
      <ThemeSwitch />
    </v-app-bar>
</template>

<script>
    import ThemeSwitch from "@/components/ThemeSwitch";

    export default {
        components: {ThemeSwitch},
        data: () => ({
            button: [
                {
                    title: "Über uns",
                    ref: "#about"
                },
                {
                    title: "Anwalt",
                    ref: "#lawyer"
                }
            ]
        }),
        methods: {
            route: function(){
                return this.$route.fullPath === "/";
            }
        }
    }

</script>
